import LoadingIcon from "@/components/layout/loading-icon";
import type { ChainData } from "@/constants/chain-details";
import type { DispenserResponse } from "@/features/dispenser/hooks/useDispenser";
import { motion } from "framer-motion";
import Image from "next/image";
import toast from "react-hot-toast";
import { BiChevronDown, BiInfoCircle } from "react-icons/bi";
import styles from "./index.module.scss";

type Props = {
  onOpen: () => void;
  allSettings: DispenserResponse | null | undefined;
  chain: ChainData | undefined;
  isLoading: boolean;
};

const ChainBtn = ({ onOpen, allSettings, chain, isLoading }: Props) => {
  const renderButtonContent = () => {
    if (isLoading) {
      return <LoadingIcon size={30} />;
    }

    return (
      <>
        {chain && (
          <Image
            src={chain.logo}
            alt={chain.chainName}
            width={25}
            height={25}
          />
        )}
        {chain?.chainName && (
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className={styles.text}
          >
            {chain.chainName}
          </motion.span>
        )}
        {!chain && (
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className={styles.text}
          >
            No chains available
          </motion.span>
        )}
        {allSettings && allSettings.destinations.length > 1 && (
          <BiChevronDown size={25} />
        )}
      </>
    );
  };

  const handleInfo = () => {
    toast(
      "You can receive your Bless on any of the chains listed. The rate may vary depending on the chain.",
      {
        icon: "ℹ️",
        duration: 7000,
      },
    );
  };

  const isButtonDisabled =
    !allSettings || (!!allSettings && allSettings.destinations.length < 2);

  return (
    <>
      <span className={styles.headerText}>Receive BLESS on:</span>
      <div className={styles.info}>
        <BiInfoCircle onClick={handleInfo} />
      </div>
      <button
        className={styles.chainSelector}
        onClick={onOpen}
        disabled={isButtonDisabled}
      >
        {renderButtonContent()}
      </button>
    </>
  );
};

export default ChainBtn;
